import React from "react";
import { inject, observer } from 'mobx-react'
import FontAwesome from 'react-fontawesome';
import {Holdable, defineHold} from 'react-touch';
import {Button, ButtonGroup, FormGroup} from "reactstrap";
import {Link, Redirect, withRouter} from "react-router-dom";
import {Component} from "react/lib/ReactBaseClasses";
import CardListaStore from "../stores/CardListaStore";
import {extendObservable} from "mobx";
import _ from "lodash"
import PropTypes from 'prop-types';
import loading from '../../../assets/images/ajax-loader.gif';



@inject("store")
@observer
class CardClick extends Component {
    constructor(props, context) {
        super(props, context);
    }

    changeRoute = (to) => {
        this.props.history.push(to)
    };

    render() {
        let action = <div>
            {this.props.children}
        </div>;
        if(this.props.quantidadeSelecionados === 0) {
            if(_.get(this.props.botoes, "props.children[0].props.to")) {
                action = <div className="card-link" onClick={() => this.changeRoute(this.props.botoes.props.children[0].props.to)} >
                    {this.props.children}
                </div>
            } else if(_.get(this.props.botoes, "props.children[0].props.onClick")) {
                action = <div className="card-link" onClick={(...props) => this.props.botoes.props.children[0].props.onClick(...props)} >
                    {this.props.children}
                </div>
            }
        }
        return (
            <div>
                {action}
            </div>
        )
    }
}

export default withRouter(CardClick)
